import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export function useFeatureFlags() {
  const { token } = useAuth();
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchFeatures = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await axios.get(`${API}/api/features/my-features`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFeatures(res.data);
    } catch {
      // Default: all features hidden
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchFeatures(); }, [fetchFeatures]);

  const isEnabled = (key) => features[key]?.is_active === true;
  const getVisibility = (key) => features[key]?.visibility_mode || 'hidden';

  return { features, loading, isEnabled, getVisibility, refetch: fetchFeatures };
}
